<template>
  <div>
    <v-container>
    <v-layout wrap>
      <Title>Contact</Title>
    <v-flex xs12>
      <span style="font-size: 16pt;">Let's work together.  Contact us and let us know what we can do for you.</span>
    </v-flex>
    <v-flex xs12>
      <span style="font-size: 16pt;"><br /><br></span>
    </v-flex>
    <v-flex xs12 md5 lg4>
      <span style="font-size: 12pt; font-weight: bold">Number:</span><br/>
      <span style="font-size: 16pt;">
        <v-icon size="20">phone</v-icon>&nbsp;
        <a style="font-size: 16pt;" :href="phoneLink">{{phoneValue}}</a>
      </span>
      <br /><br />
      <span style="font-size: 12pt; font-weight: bold">Email:</span><br/>
      <span style="font-size: 14pt;">{{contactEmail}}</span><br><br>
      <span style="font-size: 12pt; font-weight: bold">Address:</span><br/>
      <span style="font-size: 14pt;">{{street}}<br />{{city}}, {{state}} {{zip}}</span>
      <span><br /><br /><br /><br /></span>
    </v-flex>
    <v-flex xs12 md7 lg8 style="text-align: center">Send us a message or request a quote
      <v-form v-model="valid">
        <v-text-field
                v-model="name"
                label="Name"
                required
                :rules="[() => !!name || 'Name is required',
                () => !!name && name.length >= 2 || 'Name must be at least 2 characters long']"
                prepend-icon="face"
        ></v-text-field>
        <v-text-field
                v-model="phone"
                label="Phone"
                :rules="[() => !!phone || 'Phone number is required',
                () => !!phone && phone.length >= 10 || 'Phone number must be at least 10 characters long']"
                prepend-icon="phone"
                required
        ></v-text-field>
        <v-text-field
                v-model="email"
                label="E-mail"
                :rules="[() => !!email || 'Email is required',
                () => !!email && email.length >= 5 || 'Email must be at least 5 characters long',
                v => /.+@.+/.test(v) || 'Invalid Email address']"
                prepend-icon="email"
                required
        ></v-text-field>

        <v-textarea
                outline
                v-model="message"
                label="Comments/Questions"
                :rules="[() => !!message || 'Comments are required',
                () => !!message && message.length >= 5 || 'Comments must be at least 5 characters long']"
                value=""
                hint="Please enter any comments or questions you have for us!"
        ></v-textarea>

        <v-btn
                color="warning"
                @click="sendMessage"
        >
          Send Message
        </v-btn>
      </v-form>
    </v-flex>
    </v-layout>
    </v-container>  </div>
</template>

<script>
  import Title from './Title'
  const axios = require('axios');
  import { sync } from 'vuex-pathify';

  export default {
    name: 'Contact',
    components: { Title },
    data () {
      return {
        nameRules: ['checkNameLength'],
        valid: false,
        name: null,
        phone: null,
        email: null,
        message: null
      }
    },
    computed: {
      ...sync(['serviceUrl','serviceEndpoints.SEND_EMAIL', 'contactEmail','siteName', 'siteSubname', 'phoneLink',
        'phoneValue','street', 'city', 'state', 'zip'])
    },
    methods: {
      sendMessage: function() {
        let me = this;
        if (!this.valid) {
          alert('Please complete the form before sending us a message. Thanks!');
          return;
        }
        axios.post(this.serviceUrl + this.SEND_EMAIL + this.contactEmail, {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message
        })
        .then(function () {
          alert('Your message has been submitted!');
        })
        .catch(function (error) {
          alert('There was an error sending you\'re message.  Please try again later.');
        })
      }
    }
  }
</script>

<style>
</style>
